import schema from './schema'
import getters from './getters'
import actions from './actions'

export default {
  modelGetters: {},
  listGetters: {
    filter_commitments_without_tsc() {

    },
    filter_todays_commitments() {
      /*
      All of todays' commitments with:
      - done: yes / no
      - progress %
      - Num of commitments

      Update every n sec
      */
    },
  },
  staticGetters: getters,
  staticActions: actions,
  schema: schema
};
